import { withChartLayout } from 'components/common';
import { BallardMaturationalAssessmentStandalone } from 'components/features/chart/special-charts/ballard-maturational-assessment/BallardMaturationalAssessment';

const BallardMaturationalAssessmentPage = withChartLayout('Ballard Maturational Assessment')(BallardMaturationalAssessmentStandalone);
export default BallardMaturationalAssessmentPage;
